import moment from "moment";
import React, { useEffect, useState } from "react";
import * as RB from "react-bootstrap";
import * as utils from "../../Utils/comman";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../../reducers/userProfileSlice";
import "react-quill/dist/quill.snow.css"; // import styles for the editor

function LogisticLoadingView(props) {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    orderId: "",
    llDate: new Date(),
    dcNo: "",
    startTime: "",
    endTime: "",
    vehicleNo: "",
    transporterName: "",
    partyName: "",
    lrNo: "",
    soNo: "",
  });
  const [shipments, setShipments] = useState([
    {
      shipmentId: "",
      shipmentName: "",
      address: "",
      addressType: "",
      shipmentMethod: "",
      godownId: "",
      godownName: "",
      items: [
        {
          productId: 0,
          productName: "",
          batchNo: "",
          mfg: "",
          noBags: "",
          remarks: "",
          qty: 0,
          location: "",
        },
      ],
    },
  ]);
  const userProfile = useSelector((state) => state?.userProfile?.userProfile);
  const [piData, setPiData] = useState([]);
  const [orderId, setOrderId] = useState(0);
  const [officeLocation, setOfficeLocation] = useState([]);

  useEffect(() => {
    setOrderId(
      props?.rowData?.orderdata && props?.rowData?.orderdata.id
        ? props?.rowData?.orderdata.id
        : props?.rowData?.id
    );
    getLocationList();
  }, []);

  useEffect(() => {
    if (orderId > 0 && officeLocation) {
      getLoadingData();
    }
  }, [orderId, officeLocation]);

  const getLoadingData = () => {
    utils
      .callAPI("get", `/sales/getlogisticDataList?id=${orderId}`)
      .then((res) => {
        if (typeof res !== "undefined") {
          const piData = res?.pi_response;
          const shipments = [];

          setPiData(piData);

          if (res.logisticdata) {
            const logisticData = res?.logisticdata;

            res?.shipment &&
              res?.shipment.map((shipmentData, index) => {
                const shipmentItems = [];
                const groupedShipmentItems = {};
                // shipmentData.items.map(item => {
                logisticData
                  .filter((l) => l.shipment_id === shipmentData.id)
                  .sort((a, b) =>
                    a.office_location_id > b.office_location_id ? 1 : -1
                  )
                  .forEach((item) => {
                    // const product = shipmentData.items.find(
                    //   (p) => parseInt(p.id) === parseInt(item.product_id)
                    // );
                    const product = shipmentData.items.find(
                      (p) => parseInt(p.item_name) === parseInt(item.product_id)
                    );

                    const officeLocationId = item.office_location_id;

                    if (!groupedShipmentItems[officeLocationId]) {
                      groupedShipmentItems[officeLocationId] = {
                        locationId: officeLocationId,
                        locationName: officeLocation.find(
                          (l) => l.id === officeLocationId
                        )?.name,
                        items: [],
                      };
                    }
                    {
                      console.log("So the prod", item, product);
                    }
                    // Add the item to the appropriate location group
                    groupedShipmentItems[officeLocationId].items.push({
                      id: item.id,
                      productId: item.product_id,
                      productName: product?.product_name,
                      batchNo: item?.batch_no,
                      mfg: item?.mfg,
                      noBags: item?.no_of_bags ?? 0,
                      qty: product?.item_qty,
                      remarks: item?.remarks,
                      location: item?.office_location_id,
                    });
                  });
                const shipment = {
                  shipmentId: shipmentData.id,
                  shipmentName: shipmentData.shipment_name,
                  address: shipmentData.address,
                  addressType: shipmentData.address_type,
                  shipmentMethod: shipmentData.shipment_method,
                  godownId: shipmentData.godown_id,
                  godownName: shipmentData.godown_name,
                  items: Object.values(groupedShipmentItems),
                };

                shipments.push(shipment);
              });
          }

          setShipments(shipments);
        } else {
          const propdata = { mode: "list" };
          props.onChange(propdata);
        }
      })
      .catch((err) => {
        const propdata = { mode: "list" };
        props.onChange(propdata);
      });
  };

  useEffect(() => {
    if (!userProfile) {
      dispatch(fetchUserProfile());
    }
  }, [userProfile]);

  const handleBackClick = () => {
    const propdata = {
      mode: "list",
    };
    props.onChange(propdata);
  };

  const getLocationList = () => {
    utils
      .callAPI("get", `/sales/getLocationList`)
      .then((res) => {
        if (typeof res !== "undefined") {
          setOfficeLocation(res.result);
        } else {
          setOfficeLocation([]);
        }
      })
      .catch((err) => {
        setOfficeLocation([]);
      });
  };

  const handleDownload = () => {
    utils
      .callAPI(
        "get",
        `/sales/download_loading_challan/${props?.rowData?.pi_response?.id}`
      )
      .then((res) => {
        if (typeof res !== "undefined") {
          //window.open(res, "_blank");
          const a = document.createElement("a");
          a.href = res;
          a.target = "_blank"; // or "_self" depending on your preference
          a.rel = "noopener noreferrer";
          a.click();
        } else {
          //setPiData([]);
        }
      })
      .catch((err) => {
        // setPiData([]);
      });
  };

  return (
    <div className="section-body ">
      <RB.Card className="">
        <RB.Card.Header>
          <h4>Logistic Loading Sheet</h4>
          <div className="card-header-action">
            <RB.Button
              className="btn btn-primary me-2"
              onClick={handleDownload}
            >
              Download PDF
            </RB.Button>
            <RB.Button
              className="btn btn-primary me-2"
              onClick={handleBackClick}
            >
              Back
            </RB.Button>
          </div>
        </RB.Card.Header>
        <RB.Card.Body>
          <RB.Card className="border-0">
            <RB.CardBody className="p-0 border-0">
              <RB.Row>
                <RB.Col md={3} sm={6}>
                  <div className="mb-3 mt-3">
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      Date
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {moment(piData?.loading_date).format("DD-MMM-YYYY")}
                    </p>
                  </div>
                </RB.Col>

                <RB.Col md={3} sm={6}>
                  <div className="mb-3 mt-3">
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      Delivery Challan No.
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {piData?.deliverynoteno}
                    </p>
                  </div>
                </RB.Col>

                <RB.Col md={3} sm={6}>
                  <div className="mb-3 mt-3">
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      Start Time
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {piData?.loading_start_time
                        ? moment(piData?.loading_start_time).format("hh:mm A")
                        : ""}
                    </p>
                  </div>
                </RB.Col>

                <RB.Col md={3} sm={6}>
                  <div className="mb-3 mt-3">
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      End Time
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {piData?.loading_end_time
                        ? moment(piData?.loading_end_time).format("hh:mm A")
                        : ""}
                    </p>
                  </div>
                </RB.Col>

                <RB.Col md={12}>
                  <hr className="m-0" />
                </RB.Col>
              </RB.Row>

              <RB.Row>
                <RB.Col md={4} sm={6}>
                  <div className="mb-3 mt-3">
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      Vehical No.
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {piData?.motor_vehicle_no}
                    </p>
                  </div>
                </RB.Col>

                <RB.Col md={4} sm={6}>
                  <div className="mb-3 mt-3">
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      Transporter Name
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {piData?.transporter_name}
                    </p>
                  </div>
                </RB.Col>

                <RB.Col md={4} sm={6}>
                  <div className="mb-3 mt-3">
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      Party Name
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {props.rowData?.channel_details?.companyName}
                    </p>
                  </div>
                </RB.Col>
                <RB.Col md={12}>
                  <hr className="m-0" />
                </RB.Col>
              </RB.Row>

              <RB.Row>
                <RB.Col md={6} sm={6}>
                  <div className="mb-3 mt-3">
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      L.R. No.
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {piData?.bill_of_landing_lr_rr_no}
                    </p>
                  </div>
                </RB.Col>

                <RB.Col md={6} sm={6}>
                  <div className="mb-3 mt-3">
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      S.O. No.
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {props.rowData?.order_id}
                    </p>
                  </div>
                </RB.Col>
              </RB.Row>
            </RB.CardBody>
          </RB.Card>

          {shipments &&
            shipments.map((shipment, index) => (
              <RB.Card key={index}>
                <RB.CardHeader>
                  <h4>{shipment.shipmentName}</h4>
                </RB.CardHeader>
                <RB.CardHeader>
                  <RB.Row className="w-100">
                    <RB.Col md={2} sm={2}>
                      <span className="text-uppercase fw-bold small text-body-secondary ">
                        Type
                      </span>
                      <p className="fw-medium text-sm fw-semibold mb-0">
                        {shipment?.addressType}
                      </p>
                    </RB.Col>
                    {shipment.godownId !== "0" && (
                      <RB.Col md={3} sm={5}>
                        <span className="text-uppercase fw-bold small text-body-secondary">
                          Godown
                        </span>
                        <p className="fw-medium text-sm fw-semibold mb-0">
                          {shipment.godownName}
                        </p>
                      </RB.Col>
                    )}
                    <RB.Col md={3} sm={5}>
                      <span className="text-uppercase fw-bold small text-body-secondary">
                        Shipping Method
                      </span>
                      <p className="fw-medium text-sm fw-semibold mb-0">
                        {shipment?.shipmentMethod}
                      </p>
                    </RB.Col>
                    <RB.Col md={true}>
                      <span className="text-uppercase fw-bold small text-body-secondary">
                        Shipping Address
                      </span>
                      <p className="fw-medium text-sm fw-semibold mb-0">
                        {shipment?.address}
                      </p>
                    </RB.Col>
                  </RB.Row>
                </RB.CardHeader>
                <RB.CardBody className="ll-custom-table-view">
                  <RB.Row className="table-row table-header-row">
                    <RB.Col md={1} className="table-col table-col-header">
                      Sr. No.
                    </RB.Col>
                    <RB.Col md={true} className="table-col table-col-header">
                      Products
                    </RB.Col>
                    <RB.Col md={2} className="table-col table-col-header">
                      Batch No.
                    </RB.Col>
                    <RB.Col md={2} className="table-col table-col-header">
                      Mfg.
                    </RB.Col>
                    <RB.Col md={2} className="table-col table-col-header">
                      No. of Bags / Containers / Barrels
                    </RB.Col>
                    <RB.Col md={2} className="table-col table-col-header">
                      Remarks
                    </RB.Col>
                  </RB.Row>
                  {shipment.items &&
                    shipment.items.map((groupItem, i) => (
                      <>
                        <RB.Row key={i} className="table-row">
                          <RB.Col className="table-col">
                            Destination Center:&nbsp;
                            <strong>{groupItem.locationName}</strong>
                          </RB.Col>
                        </RB.Row>
                        {groupItem.items &&
                          groupItem.items.map((item, j) => (
                            <RB.Row key={j} className="table-row">
                              {console.log("here is the ", item)}
                              <RB.Col
                                md={1}
                                className="table-col justify-content-center"
                                data-lable="Sr. No.:"
                              >
                                {j + 1}
                              </RB.Col>
                              <RB.Col
                                md={true}
                                className="table-col"
                                data-lable="Products:"
                              >
                                {item.productName}
                              </RB.Col>
                              <RB.Col
                                md={2}
                                className="table-col"
                                data-lable="Batch No.:"
                              >
                                {item.batchNo}
                              </RB.Col>
                              <RB.Col
                                md={2}
                                className="table-col"
                                data-lable="Mfg.:"
                              >
                                {item.mfg}
                              </RB.Col>
                              <RB.Col
                                md={2}
                                className="table-col text-md-center"
                                data-lable="No. of Bags / Containers / Barrels:"
                              >
                                {item.noBags}
                              </RB.Col>
                              <RB.Col
                                md={2}
                                className="table-col"
                                data-lable="Remarks:"
                              >
                                {item.remarks}
                              </RB.Col>
                            </RB.Row>
                          ))}
                      </>
                    ))}
                </RB.CardBody>
              </RB.Card>
            ))}
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default LogisticLoadingView;
